import { IInvoiceUpdateDTO, IInvoiceCorrectSum, IInvoiceCreateDTO, IInvoiceGetDTO, IInvoiceViewDTO } from "../../coreapi-dto/documents/invoice";
import { ICreateDocumentFromItemsRequest, IInvoiceItemViewDTO } from "../../coreapi-dto/documents/invoiceItem";
import { CoreApiResponse, ICoreCompletedResponse, IRequestEventHandler } from "../common";
import { BaseDocRequestV2 } from "./baseDocRequestV2";
import { ContentType } from "../../fetchApiDistributor/contentTypes";
import { ICreateDocumentsResponse } from "../../coreapi-dto/accounting/lot";

class InvoiceRequest extends BaseDocRequestV2<IInvoiceViewDTO, IInvoiceGetDTO, IInvoiceCreateDTO, IInvoiceUpdateDTO, IInvoiceItemViewDTO, IInvoiceGetDTO> {

    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl, "invoice", token, eventHandler)
    }

    create(body: IInvoiceCreateDTO, callback: (e: CoreApiResponse<string>) => void) {
        super.create(body, callback)
    }

    update(idGlobal: string, body: IInvoiceUpdateDTO, callback: (e: CoreApiResponse<null>) => void) {
        super.update(idGlobal, body, callback)
    }

    updateEditKizs(idDocumentGlobal: string, idDocumentItemGlobal: string, body: IInvoiceUpdateDTO, callback: (e: CoreApiResponse<null>) => void) {
        this.put(`${this._baseUrl}/${this._routePrefix}/${idDocumentGlobal}/${idDocumentItemGlobal}/UpdateEditKizs`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                this._eventHandler.onGetResponse(e)
            }
            callback?.(e);
        })
    }

    correctSum(idDocumentGlobal: string, body: IInvoiceCorrectSum, callback: (e: CoreApiResponse<null>) => void) {
        this.put(`${this._baseUrl}/${this._routePrefix}/${idDocumentGlobal}/CorrectSum`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                this._eventHandler.onGetResponse(e)
            }
            callback?.(e);
        })
    }

    getViewProc(body: IViewBody, callback?: (e: CoreApiResponse<IViewWrapper<IInvoiceViewDTO>>,) => void) {
        this.post<IViewWrapper<IInvoiceViewDTO>>(`${this._baseUrl}/${this._routePrefix}/ViewProc`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                } else {
                    callback?.(e);
                }
            }

        })
    }

    createDepositedCheque(idDocumentGlobal: string, callback: (e: CoreApiResponse<string>, testApi?: { name: string, time: number }) => void) {
        this.post<string>(`${this._baseUrl}/${this._routePrefix}/${idDocumentGlobal}/CreateDepositedCheque`, null, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                    callback?.(e);
                } else {
                    callback?.(e as ICoreCompletedResponse<string>, { name: `${this._routePrefix}/CreateDepositedCheque`, time: e.time as number });
                }

            }
        })
    }

    сreateDocumentFromItems(request: ICreateDocumentFromItemsRequest, callback?: (e: CoreApiResponse<ICreateDocumentsResponse>) => void, testApi?: ({ name, time }) => void, callbackFailed?: (e) => void) {
        this.post<ICreateDocumentsResponse>(`${this._baseUrl}/${this._routePrefix}/CreateDocumentFromItems`, request, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                    callbackFailed?.(e);
                } else {
                    callback?.(e as ICoreCompletedResponse<ICreateDocumentsResponse>);
                }

            }
        })
    }

    repeatInfoGismtEnabled(idDocumentGlobal: string, callback?: (e: CoreApiResponse<boolean>) => void) {
        this.get<boolean>(`${this._baseUrl}/${this._routePrefix}/${idDocumentGlobal}/RepeatInfoGismtEnabled`, [this.getBearerHeader(this._token)], (e) => {
            callback?.(e);
        })
    }

}
export default InvoiceRequest